






























import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import moment from "moment-timezone";
import ReportDateFilter from "./ReportDateFilter2.vue";

const { mapActions: reportsActions } = createNamespacedHelpers("reports");

const tz = localStorage.getItem("tz") ?? "Africa/Nairobi";
export default Vue.extend({
  name: "TopFilter",
  components: {
    ReportDateFilter,
  },

  props: {
    cardView: {
      default: false,
    },
  },
  data: () => ({
    startDate: null as string | null,
    endDate: null as string | null,
    applyDateFilter: true,
    applyFilter: [] as unknown[],
    filterStart: null as string | null,
    filterEnd: null as string | null,
    params: {} as Record<string, string | null>,
    stats: 0,
    statsTitle: "",
  }),
  computed: {
    formattedStats() {
      const value = this.stats || 0;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  methods: {
    ...reportsActions(["fetchTopFilterStats"]),
    numberWithCommas(value: number | string): string {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getParams() {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);

      this.params = {
        method: params.get("method"),
        startDate: params.get("startDate"),
        endDate: params.get("endDate"),
        type: params.get("type"),
        staff: params.get("staff"),
      };
    },

    toggleFilter() {
      if (this.applyDateFilter) {
        this.applyDateFilter = true;
      } else {
        this.applyDateFilter = false;
      }
    },
    onRangeChange(filters) {
      this.filterStart = filters.start;
      this.filterEnd = filters.end;

      if (this.applyDateFilter) {
        this.startDate = filters.start;
        this.endDate = filters.end;
        this.fetchSalesReports();
        this.$emit("dateChanged", {
          startDate: this.startDate,
          endDate: this.filterEnd,
        });
      }
    },
    async fetchSalesReports() {
      try {
        const result = await this.fetchTopFilterStats({
          reportType: this.params.type,
          method: this.params.method,
          staff: this.params.staff,
          startDate: this.startDate,
          endDate: this.endDate,
        });

        this.stats = result.stats;
        this.statsTitle = result.statsTitle;
      } catch (error) {
        console.error("Failed to fetch sales reports:", error);
      }
    },
    formatDate(date: string) {
      if (!date) return null;

      return moment(date).tz(tz).format("DD/MM/YYYY");
    },
    clear() {
      this.startDate = null;
      this.endDate = null;
    },
    setFilters(value: boolean) {
      this.applyDateFilter = value;
    },
    navigate(item: { report_name: string }) {
      const query: Record<string, string> = {
        tab: "orders",
        type: item.report_name.toLowerCase().slice(0, -1),
      };
      if (this.startDate) {
        const date = new Date(this.startDate);
        date.setHours(0, 0, 0, 0);
        query.startDate = date.toISOString();
      }
      if (this.endDate) {
        const date = new Date(this.endDate);
        date.setHours(23, 59, 59, 59);
        query.endDate = date.toISOString();
      }
      // Navigate to products page
      window.location.href = `/products?${new URLSearchParams(
        query
      ).toString()}`;
    },
  },
  watch: {
    applyDateFilter(x) {
      if (!x) {
        this.startDate = null;
        this.endDate = null;
        this.$emit("dateChanged", {
          startDate: this.startDate,
          endDate: this.endDate,
        });
      } else {
        this.startDate = this.filterStart;
        this.endDate = this.filterEnd;
        this.$emit("dateChanged", {
          startDate: this.startDate,
          endDate: this.endDate,
        });
      }
    },
    startDate() {
      this.fetchSalesReports();
    },
    endDate() {
      this.fetchSalesReports();
    },
  },
  mounted() {
    console.log("mounted");
    this.getParams();
    this.fetchSalesReports();
  },
});
